import { render, staticRenderFns } from "./Modal2.vue?vue&type=template&id=1bbe9c3a"
import script from "./Modal2.vue?vue&type=script&lang=js"
export * from "./Modal2.vue?vue&type=script&lang=js"
import style0 from "./Modal2.vue?vue&type=style&index=0&id=1bbe9c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports